import { SET_STORIES_DATA, ADD_STORIES_DATA } from '../actions/types';

export default function stories(state = [], action = null) {
	if (!action.error && action.payload && action.type) {
		switch (action.type) {
			case SET_STORIES_DATA:
				return action.payload;
			case ADD_STORIES_DATA:
				return [...state, ...action.payload];
			default:
				break;
		}
	}
	return state;
}
